
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";

const TimerPopup = ({ timerShowHide, handleTimerModalShowHide, tmrMessages }) => {
    return (
        <Modal show={timerShowHide} size="xl">
            <Modal.Header closeButton onHide={handleTimerModalShowHide}>
                <Modal.Title>Timer Notification</Modal.Title>
            </Modal.Header>
            <Modal.Body className="border">
                <div className="row">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <table className="table table-striped align-items-center table-flush border">
                                <thead className="thead-light">
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Date & Time</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tmrMessages.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <Moment format="MMM Do YYYY, h:mm a">
                                                    {item.endDateTime}
                                                </Moment>
                                            </td>
                                            <td style={{ whiteSpace: "pre-wrap" }}>
                                                {decodeURIComponent(item.message)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
        <button className="btn btn-sm btn-outline-default" onClick={handleTimerModalShowHide}>
          <i className="fa fa-times" aria-hidden="true"></i> Close
        </button>
      </Modal.Footer> */}
        </Modal>
    );
};

export default TimerPopup;